import Vue from "vue";
import "../vue-components/helpers/vue-filters.js";
import "../vue-components/helpers/vue-directives.js";
import "../vue-components/helpers/vue-mixin.js"

Vue.mixin({
    computed: {
        devMode() {
            return process.env.NODE_ENV === `development`;
        }
    },
    methods: {
        reach(url) {
            if (this.$route.path !== url)
                this.$router.push(url);
        }
    }
});

export default {};
